module.exports = __webpack_public_path__ + "f675510253b173366c01e7c6ca5e5439.png";